var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('navigator'),_c('div',{staticClass:"main-body"},[_c('router-view')],1),_c('footer-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }